import { Card, CardContent, TextField } from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import React from "react";
import { useIntl } from "react-intl";

import { PageheaderPageFormData } from "../PageheaderPage";

export interface TopheaderBackgroundColorProps {
  mainColor: string;
  secondaryColor: string;
  disabled: boolean;
  onChange: (event: any) => void;
}
const TopheaderBackgroundColor: React.FC<TopheaderBackgroundColorProps> = ({
  mainColor,
  secondaryColor,
  disabled,
  onChange
}) => {
  const intl = useIntl();

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Background Color",
          description: "Background Color"
        })}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Background Color PC",
            description: "Background Color"
          })}
          name={"mainColor" as keyof PageheaderPageFormData}
          fullWidth
          value={mainColor}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Background Color MB",
            description: "Background Color"
          })}
          name={"secondaryColor" as keyof PageheaderPageFormData}
          fullWidth
          value={secondaryColor}
          onChange={onChange}
        />
        <FormSpacer />
        <div
          style={{
            borderColor: mainColor,
            borderWidth: 2,
            borderStyle: "solid",
            background: secondaryColor,
            width: "120px",
            height: "30px",
            marginRight: "20px",
            textAlign: "center",
            paddingTop: "5px"
          }}
        />
        <FormSpacer />
      </CardContent>
    </Card>
  );
};
export default TopheaderBackgroundColor;
